import { Outlet } from 'react-router';

import { usePublicBrand } from '@/platform/brand/use-public-brand';
import { AppLogoLink } from '@/platform/components/app-logo-link';
import { PlatformChrome } from '@/platform/components/platform-chrome';

/** Chrome for Mitarbeiterportal hub and non-Helpdesk products. */
export function PlatformShellLayout() {
  const brand = usePublicBrand();
  const tenantName = brand.data?.name?.trim();

  return (
    <PlatformChrome
      brand={
        <AppLogoLink
          title={
            <span className="leading-tight">
              <span className="hidden sm:inline">
                Mitarbeiterportal
                {tenantName ? (
                  <span className="font-normal text-muted-foreground"> · {tenantName}</span>
                ) : null}
              </span>
              <span className="sm:hidden">Portal</span>
            </span>
          }
        />
      }
      mainClassName="py-8"
    >
      <Outlet />
    </PlatformChrome>
  );
}
